// ! Add new things to the end. Also if you try to delete things here. Filter them out in the UI. The sorting is also relevant
// These values get exported via an index into the lodas ascii import. If things change itz will break some references in lodas.

export enum Lohnart {
  INDIVIDUELLE_ENDSTUFE = 'individuelle Endstufe',
  ENTGELT = 'Entgelt',
  ENTGELT_2TARIFVERTRÄGE = '2 Tarife',
  FZ_VERH_BE = 'FZ-Verh-Be',
  BESITZ_KIND = 'Besitz Kind',
  STELLENZULAGE = 'Stellenzulage',
  FESTGEHALT_MINIJOB = 'Festgehalt (Minijob)',
  VL_ZULAGE = 'VL-Zulage',
  SONST_ZULAGE = 'Sonst.Zulage',
  AT_ENTGELT = 'AT-Entgelt',
  FSJ_TASCHENGELD = 'FSJ Taschengeld',
  FSJ_FAHRTKOSTEN = 'FSJ Fahrtkosten',
  VERGGRPZUL = 'VergGrpZul',
  LEISTZULAGE = 'Leistungszulage',
  STRUKT_AUSGL = 'Strukt.ausgl',
  JOBTICKET = 'Jobticket',
  FSJ_VERPFLEGUNG = 'FSJ Verpflegung',
  INFLATIONPRAEMIE = 'Inflationsprämie',
  JAHRESSONDERZAHLUNG = 'Jahressonderzahlung',
  MEHR_ARBEIT = 'Mehrarbeit',
  STUNDENLOHN = 'Stundenlohn',
}
